'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LbsSdkConfig = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LBS - Node.js SDK
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * V1.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Author - Sonic Tao
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * */


var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

var _nodes = require('./clients/nodes');

var _nodes2 = _interopRequireDefault(_nodes);

var _permissions = require('./clients/permissions');

var _permissions2 = _interopRequireDefault(_permissions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultOptions = {
  getEventEmitter: function getEventEmitter() {
    return 'fake-emitter';
  },
  getAccessToken: function getAccessToken() {
    return Promise.resolve('fake-token');
  },
  getCsrfToken: function getCsrfToken() {
    return null;
  }
};
/** main CSE class */

var LbsSdk = function () {
  /** CSE constructor */
  function LbsSdk(options) {
    _classCallCheck(this, LbsSdk);

    // Do not store token here.
    // this.token = getToken();
    var envConfig = new _config2.default(options);
    this.apiOptions = _extends({}, defaultOptions, options, { baseUrl: envConfig.baseUrl });
  }

  _createClass(LbsSdk, [{
    key: 'getNode',
    value: function getNode(projectId, treeId) {
      if (!treeId) {
        treeId = 'default';
      }
      this.node = new _nodes2.default(_extends({}, this.apiOptions, { projectId: projectId, treeId: treeId }));
      return this.node;
    }
  }, {
    key: 'getPermissions',
    value: function getPermissions(projectId) {
      this.permission = new _permissions2.default(_extends({}, this.apiOptions, { projectId: projectId }));
      return this.permission;
    }
  }]);

  return LbsSdk;
}();

exports.default = LbsSdk;
exports.LbsSdkConfig = _config.ENVS;